import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CpaEnPlaya {
  getCpaEnPlaya () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cpa_en_playa_listado?r=` +
    `{"orden": ["d:clave_cereal","turno_de_salida"]}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado de camiones en playa.')
      return data
    })
  };

  static async getDataCamionesEnPlaya () {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_cpa_en_playa_listado?r=` +
    `{"orden": ["d:clave_cereal","turno_de_salida"]}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static getById (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cpa_en_playa?r=` +
      `{"clave":{"numero":"${id}"}}`)

    return promise.then(lrsAdapter)
      .then(response => (response.data[0] || {}))
      .catch(_ => [])
  }

  static getByCamion (camion) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cpa_en_playa_por_camion?r=` +
      `{"clave":{"camion":"${camion}"}}`)

    return promise.then(lrsAdapter)
      .then(response => (response.data[0] || {}))
      .catch(_ => [])
  }

  static egresoCpaPlaya (cpa) {
    const axios = getAxiosInstance()
    const promise = axios.post(`carta_de_porte_automotor_egreso_playa`,
      `{"valores": {"numero": "${cpa.numero}", "exportador": "${cpa.cuitExportador}",
        "cereal": "${cpa.claveCereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then(response => (response.data || {}))
  }

  static turnosPendientesEgreso (turno, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`turnos_pendientes_egreso_playa?r=` +
      `{"parametros": {"turno": ${turno}, "tipo_cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }
}

export default CpaEnPlaya
